<template lang="pug">
    article#pagina_404
        section#pg_404
            div.wrapper
                div.codigo
                    h2 404
                    h3 A página não foi encontrada.
                    p 
                        |Você pode voltar a 
                        router-link(:to="{name: 'home'}") Página inicial 
                        |e tentar novamente
</template>

<script>
export default {
    name: "view-404"
}
</script>

<style lang="stylus" scoped src="./404.styl"></style>